import React, { Component } from 'react';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Form, Input } from 'components/antd';
import { ReferenceField } from 'app-types';
import { chunk } from 'lodash-es';

interface Props {
	form: WrappedFormUtils;
	valueInputName?: string;
	referenceFields?: ReferenceField[];
	numOfItemsInRow?: number;
	showValidationMessage?: boolean;
}

const GRID_COLS = 12;
const DEFAULT_NUMBER_OF_ITEMS_IN_ROW = 2;

export default class ReferenceFields extends Component<Props> {
	getName(index: number, name: string) {
		return `referenceFields[${index}][${name}]`;
	}

	getReferenceFields() {
		const {
			referenceFields = [],
			form,
			valueInputName = 'defaultValue',
			numOfItemsInRow = DEFAULT_NUMBER_OF_ITEMS_IN_ROW,
			showValidationMessage = false,
		} = this.props;
		const { getFieldDecorator } = form;
		const formItemProps = {};

		if (!showValidationMessage) {
			formItemProps['validateStatus'] = '';
			formItemProps['help'] = false;
		}

		return referenceFields.map((field, index) => {
			return (
				<div
					key={`cell-${field.customerReferenceFieldId}`}
					className={`modalBoxCol w${GRID_COLS / numOfItemsInRow}`}
				>
					<Form.Item label={field.referenceFieldName} {...formItemProps}>
						{getFieldDecorator(this.getName(index, valueInputName), {
							initialValue: field.value,
							rules: [
								{
									required: true,
									whitespace: true,
									...(showValidationMessage && {
										message: `${field.referenceFieldName.toUpperCase()} is required`,
									}),
								},
							],
						})(<Input />)}
					</Form.Item>
					{getFieldDecorator(this.getName(index, 'customerReferenceFieldId'), {
						initialValue: field.customerReferenceFieldId,
						rules: [
							{
								whitespace: false,
								required: false,
								type: 'number',
							},
						],
					})(<Input type={'hidden'} />)}
					{getFieldDecorator(this.getName(index, 'referenceFieldName'), {
						initialValue: field.referenceFieldName,
						rules: [
							{
								whitespace: false,
								required: false,
								type: 'string',
							},
						],
					})(<Input type={'hidden'} />)}
				</div>
			);
		});
	}

	render() {
		const { numOfItemsInRow = DEFAULT_NUMBER_OF_ITEMS_IN_ROW } = this.props;
		const referenceFields = this.getReferenceFields();
		const chunkedReferenceFields = chunk(referenceFields, numOfItemsInRow);

		return (
			<>
				{chunkedReferenceFields.map(chunk => (
					<div className="modalBoxRow" key={`row-${chunk[0].key}`}>
						{chunk}
					</div>
				))}
			</>
		);
	}
}
